import { getBaseProduct } from '../../../../helpers/getBaseProduct';
import { getCurrentVariant } from '../../../../helpers/getCurrentVariant';
import { getProductWithMeasurementsRequestBody } from '../../../../helpers/getProductWithMeasurementsRequestBody';
import {
  ProductBuilderMachineContext,
  ProductWithMeasurementsResponse,
} from '../../../../types';
import productWithMeasurements from '../../stub/productWithMeasurements.json';

export type GetProductWithMeasurementsDev = (
  context: ProductBuilderMachineContext,
) => Promise<ProductWithMeasurementsResponse>;

type GetStubResponse = (
  context: ProductBuilderMachineContext,
) => ProductWithMeasurementsResponse;

const getStubResponse: GetStubResponse = context => {
  const baseProduct = getBaseProduct(context);
  const currentVariant = getCurrentVariant(context);
  if (!baseProduct || !currentVariant) return productWithMeasurements;

  const { measurements } = context.custom;
  const [width, height] =
    typeof measurements === 'string'
      ? measurements.split('x').map(value => parseInt(value))
      : [];
  const {
    id,
    title,
    price,
    sku,
    compare_at_price,
    inventory_management,
    option1,
    option2,
    option3,
    taxable,
    barcode,
    weight,
  } = currentVariant;
  return {
    data: productWithMeasurements.data.map(({ type, attributes }) => ({
      type,
      attributes: {
        ...attributes,
        id,
        product_id: baseProduct.id,
        title,
        price: price.toString(),
        sku,
        compare_at_price:
          typeof compare_at_price === 'number'
            ? compare_at_price.toString()
            : null,
        inventory_management,
        option1,
        option2,
        option3,
        taxable,
        barcode,
        weight,
        width,
        height,
      },
    })),
  };
};

export const getProductWithMeasurementsDev: GetProductWithMeasurementsDev = context =>
  new Promise<ProductWithMeasurementsResponse>(resolve => {
    const requestBody = getProductWithMeasurementsRequestBody(context);
    const stubRespones = getStubResponse(context);
    setTimeout(() => {
      console.warn(`Not using dynamic pricing endpoint.`);
      console.log(`Request body: ${JSON.stringify(requestBody)}`);
      resolve(stubRespones);
    }, 2000);
  });
